// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ab6544cf","565":"9a39bc80"}[chunkId] + ".chunk.js";
};